import { combineReducers } from "redux";
import UserReducer from "./user/reducers";
import ProductReducer from "./products/reducers";

const rootReducers = combineReducers({
  user: UserReducer,
  products: ProductReducer,
});

export default rootReducers;
